"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Fitxer: Api
 * Autor: Jordi Riu Amblàs
 * Data: 04/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 */

var AppApi_1 = require("./AppApi");

var BbddApi =
/** @class */
function () {
  function BbddApi(appState) {
    this.sentenciaInsert = function (table, row) {
      return {
        action: 'Insert',
        table: table,
        row: row
      };
    };

    this.sentenciaUpdate = function (table, primary, values) {
      return {
        action: 'Update',
        table: table,
        primary: primary,
        values: values
      };
    };

    this.sentenciaSave = function (table, primary, values) {
      return {
        action: 'Save',
        table: table,
        primary: primary,
        values: values
      };
    };

    this.sentenciaDelete = function (table, primary) {
      return {
        action: 'Delete',
        table: table,
        primary: primary
      };
    };

    this.sentenciaExecuteProcedure = function (procedure, params) {
      return {
        action: 'ExecuteProcedure',
        procedure: procedure,
        params: params
      };
    };

    this.appState = appState;
    this.req = new AppApi_1.default(this.appState, {
      urlBD: this.appState.config.bd,
      urlBase: process.env.REACT_APP_URL_API_BBDD || 'wfserver/bbdd.api' // urlBase: 'localhost:2458'

    });
  }

  BbddApi.prototype.CancelRequest = function (miss) {
    this.req.cancelRequest(miss);
  };

  BbddApi.prototype.SqlQuery = function (sql) {
    return this.req.postRequest('SqlQuery', {
      sql: sql,
      commandTimeout: this.commandTimeout
    }, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  BbddApi.prototype.SqlInsert = function (table, row) {
    return this.req.postRequest('SqlInsert', {
      table: table,
      row: row
    }, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  BbddApi.prototype.SqlDelete = function (table, primary) {
    return this.req.postRequest('SqlDelete', {
      table: table,
      primary: primary
    }, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  BbddApi.prototype.SqlSave = function (table, primary, values) {
    return this.req.postRequest('SqlSave', {
      table: table,
      primary: primary,
      values: values
    }, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  BbddApi.prototype.SqlExecuteProcedure = function (procedure, params) {
    return this.req.postRequest('SqlExecuteProcedure', {
      procedure: procedure,
      params: params
    }, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  BbddApi.prototype.SqlExecuteFunction = function (funcio, params) {
    return this.req.postRequest('SqlExecuteFunction', {
      function: funcio,
      params: params
    }, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  BbddApi.prototype.SqlExecuteBloc = function (bloc) {
    return this.req.postRequest('SqlExecuteBloc', bloc, {
      'AjtSessio_Sescod': this.appState.sessState.sessioId
    });
  };

  return BbddApi;
}();

exports.default = BbddApi;